import { httpService } from 'src/services';
import { ApiUrl } from 'src/constants';

export function getLanguages(token: string = '') {
  return httpService.get(`${ApiUrl.getApiUrl().languages}`, {}, {
    Authorization: `Bearer ${token}`,
  });
}
